import { defineMessages, type IntlShape } from 'react-intl';
import type { BlockConfigBase, JSONSchema } from '@plone/types';
import iconSVGs from '@redturtle/qubicaamf-theme/helpers/ctaIconsHelper';

const iconChoices = [];
iconSVGs.map((el) => iconChoices.push([el.icon, el.name]));

export interface OurServicesData {
  '@type': 'ourservices';
  title: string;
  services?: Array<{
    '@id': string;
    title: string;
    icon: string;
    link: string;
  }>;
}

export const OurServicesSchema = ({
  data,
  intl,
}: {
  data: OurServicesData;
  intl: IntlShape;
}): JSONSchema => {
  const schema = {
    title: intl.formatMessage(messages.title),
    fieldsets: [
      {
        id: 'default',
        title: 'Default',
        fields: ['title', 'services'],
      },
    ],
    properties: {
      title: {
        title: intl.formatMessage(messages.title_title),
      },
      services: {
        title: intl.formatMessage(messages.service_title),
        widget: 'object_list',
        schema: {
          title: intl.formatMessage(messages.service),
          fieldsets: [
            {
              id: 'default',
              title: 'Default',
              fields: ['title', 'icon', 'link'],
            },
          ],
          properties: {
            title: {
              title: intl.formatMessage(messages.title_title),
            },
            icon: {
              title: intl.formatMessage(messages.icon_title),
              widget: 'select',
              choices: iconChoices,
            },
            link: {
              title: intl.formatMessage(messages.title_link),
              widget: 'object_browser',
              allowExternals: true,
              mode: 'link',
              return: 'single',
            },
          },
          required: [],
        },
      },
    },
    required: ['title'],
  };

  return schema;
};

const messages = defineMessages({
  title: {
    id: 'qubica_amf_theme_ourservices_title',
    defaultMessage: 'Services',
  },
  service_title: {
    id: 'qubica_amf_theme_ourservices_title_ctas',
    defaultMessage: 'CTA list',
  },
  service: {
    id: 'qubica_amf_theme_ourservices_title_cta',
    defaultMessage: 'CTA',
  },
  title_title: {
    id: 'redturtle__volto-blocks__cardwithimages_title_title',
    defaultMessage: 'Title',
  },
  icon_title: {
    id: 'qubica_amf_theme_ourservices_icon_title',
    defaultMessage: 'Icon',
  },
  title_link: {
    id: 'qubica_amf_theme_ourservices_link',
    defaultMessage: 'Href',
  },
});

export interface OurServicesSchemaConfig
  extends Omit<BlockConfigBase, 'blockSchema'> {
  blockSchema: typeof OurServicesSchema;
}
